<template>
  <div class="index">
    <div class="client-title">
      <h1>茶叶全周期数据化平台</h1>
      <h3>湖南湘丰茶业---炒青绿茶</h3>
    </div>
    <!--视图展示-->
    <div :class="`content-${layout}`">
      <!--主视图-->
      <div class="center-view">
        <command
          :is="'v-map'"
          :chinaGeoCoordMap="chinaGeoCoordMap"
          :chinaDatas="chinaDatas"
        />
      </div>
      <div class="view" v-for="(item, index) in chartDatas" :key="index">
        <dv-border-box-8 :dur="8">
          <component
            :is="item.type"
            :componentData="item.data"
            :title="item.title"
            :templateStyle="item.templateStyle"
          />
        </dv-border-box-8>
      </div>
    </div>
  </div>
</template>

<script>
import { chartDatas, chinaGeoCoordMap, chinaDatas } from '../../data/data.js'

export default {
  data () {
    return {
      layout: 'grid',
      num: 7,
      // 给侧边视图固定宽高，根据布局结构来决定
      // viewSize: {
      //   width: '480px',
      //   height: '280px'
      // },
      chartDatas,

      // 地图相关数据
      chinaGeoCoordMap,
      chinaDatas
    }
  }
}

</script>

<style lang="scss" scoped>
.index {
  // 固定宽高
  width:1920px;
  height:1000px;
  // width: 1920px;
  // height: 1000px;
  background: url("../../assets/images/bg2.png");
  background-size: 1920px 1000px;
  background-position-y: -40px;
  .client-title {
    position: fixed;
    top: 80px;
    left: 960px;
    transform: translateX(-50%);
    color: #ffffff;
    z-index: 999;
    text-align: center;
    background: #0077c8;
    padding: 5px 20px;
  }
  .content-grid {
    width: 1920px;
    height: 1000px;
    //width: 100vw;
    //height: 100vh;
    display: grid;
    grid-template-columns: 520px 740px 520px;
    grid-template-rows: 330px 330px 330px;
    //grid-template-columns: 30vw 38vw 30vw;
    //grid-template-rows: 32vh 32vh 32vh;
    justify-content: space-evenly;
    align-content: space-evenly;
    grid-template-areas:
      "l c r"
      "l c r"
      "l cm r";
    .center-view {
      grid-area: c;
    }
    .view {
      //position: relative;
      //width:630px;
      //height:330px;
      overflow: hidden;
      background: rgba($color: #228fbd, $alpha: 0.4);
      background-size: 100% 100%;
    }
    :nth-child(7) {
      display: flex;
      justify-content: center;
    }
  }
  // .content-flex {
  //   width: 1920px;
  //   height: 1000px;
  //   display: flex;
  //   justify-content: space-evenly;
  //   align-content: space-between;
  //   flex-wrap: wrap;
  // }
}
</style>
